import { Suspense, lazy } from "react";
import { Routes, Route } from "react-router-dom";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";

const Landing        = lazy(() => import("./pages/Landing"));
const EffectsLibrary = lazy(() => import("./pages/EffectsLibrary"));
const EffectDetail   = lazy(() => import("./pages/EffectDetail"));
const Try            = lazy(() => import("./pages/Try"));
const DepthAsciiStudio = lazy(() => import("./pages/DepthAsciiStudio"));
const DepthPixelMosaicStudio = lazy(() => import("./pages/DepthPixelMosaicStudio"));
const BlackHoleDitherStudio = lazy(() => import("./pages/BlackHoleDitherStudio"));
const HologramFoilStudio = lazy(() => import("./pages/HologramFoilStudio"));
const CyberdreamGlowStudio = lazy(() => import("./pages/CyberdreamGlowStudio"));
const CircularMotionBlurStudio = lazy(() => import("./pages/CircularMotionBlurStudio"));
const Pricing        = lazy(() => import("./pages/Pricing"));
const Dashboard      = lazy(() => import("./pages/Dashboard"));
const SignIn         = lazy(() => import("./pages/SignIn"));
const SignUp         = lazy(() => import("./pages/SignUp"));
const Docs           = lazy(() => import("./pages/Docs"));
const NotFound       = lazy(() => import("./pages/NotFound"));

export default function App() {
  return (
    <div className="flex min-h-screen flex-col">
      <Header />
      <main className="flex-1">
        <Suspense fallback={<div className="mx-auto max-w-7xl px-6 py-24 text-center text-zinc-500">Loading…</div>}>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/effects" element={<EffectsLibrary />} />
            <Route path="/effects/:slug" element={<EffectDetail />} />
            <Route path="/try" element={<Try />} />
            <Route path="/try/depth-ascii" element={<DepthAsciiStudio />} />
            <Route path="/try/depth-pixel-mosaic" element={<DepthPixelMosaicStudio />} />
            <Route path="/try/black-hole-dither" element={<BlackHoleDitherStudio />} />
            <Route path="/try/hologram-foil" element={<HologramFoilStudio />} />
            <Route path="/try/cyberdream-glow" element={<CyberdreamGlowStudio />} />
            <Route path="/try/circular-motion-blur" element={<CircularMotionBlurStudio />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/sign-in" element={<SignIn />} />
            <Route path="/sign-up" element={<SignUp />} />
            <Route path="/docs/*" element={<Docs />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </main>
      <Footer />
    </div>
  );
}
